import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import 'bloko/blocks/icon/icon.less';

class Icon extends Component {
    static views = {
        download: 'download',
        phone: 'phone',
        excel: 'excel',
        filter: 'filter',
        list: 'list',
        lightning: 'lightning',
        listLess: 'list-less',
        listMore: 'list-more',
        edit: 'edit',
        remove: 'remove',
        skype: 'skype',
        geolocation: 'geolocation',
        basket: 'basket',
        reload: 'reload',
        plus: 'plus',
        minus: 'minus',
        done: 'done',
        cancel: 'cancel',
        chevronDown: 'chevron-down',
        chevronUp: 'chevron-up',
        chevronRight: 'chevron-right',
        chevronLeft: 'chevron-left',
        mail: 'mail',
        mailOutline: 'mail-outline',
        search: 'search',
        settings: 'settings',
        hint: 'hint',
        loading: 'loading',
        print: 'print',
        favorite: 'favorite',
        favored: 'favored',
        more: 'more',
        kebabMenu: 'kebab-menu',
        hrBrand: 'hr-brand',
        arrowRight: 'arrow-right',
        arrowLeft: 'arrow-left',
        filters: 'filters',
        ban: 'ban',
        calendar: 'calendar',
        attachment: 'attachment',
        hh: 'hh',
        vk: 'vk',
        fb: 'fb',
        mailru: 'mailru',
        instagram: 'instagram',
        gplus: 'gplus',
        li: 'li',
        ok: 'ok',
        twitter: 'twitter',
        dnr: 'dnr',
        github: 'github',
        lj: 'lj',
        stackoverflow: 'stackoverflow',
        ios: 'ios',
        android: 'android',
        winphone: 'winphone',
        uploadImage: 'upload-image',
        changePosition: 'change-position',
        message: 'message',
        whatsapp: 'whatsapp',
        viber: 'viber',
        telegram: 'telegram',
        warning: 'warning',
        clock: 'clock',
        dialog: 'dialog',
        externalLink: 'external-link',
        info: 'info',
        dropClose: 'drop-close',
        view: 'view',
        bell: 'bell',
    };

    static kinds = {
        default: 'default',
        inverted: 'inverted',
        primary: 'primary',
        secondary: 'secondary',
        tertiary: 'tertiary',
        action: 'action',
        impact: 'impact',
        unique: 'unique',
        dimmed: 'dimmed',
    };

    static propTypes = {
        /** Вид иконки [доступные варианты](#icon-view)*/
        view: PropTypes.oneOf(Object.keys(Icon.views).map((id) => Icon.views[id])),
        /** Начальное состояние иконки [доступные типы состояний](#icon-kinds) */
        initial: PropTypes.oneOf(Object.keys(Icon.kinds).map((id) => Icon.kinds[id])),
        /** Активное состояние иконки [доступные типы состояний](#icon-kinds) */
        highlighted: PropTypes.oneOf(Object.keys(Icon.kinds).map((id) => Icon.kinds[id])),
        /** Размер иконки */
        scale: PropTypes.oneOf(['24']),
    };

    static defaultProps = {
        initial: Icon.kinds.default,
    };

    render() {
        const { view, initial, highlighted, scale, ...iconProps } = this.props;

        const className = classnames('bloko-icon', {
            [`bloko-icon_${view}`]: view,
            [`bloko-icon_initial-${initial}`]: initial,
            [`bloko-icon_highlighted-${highlighted}`]: highlighted,
            [`bloko-icon_${scale}`]: scale,
        });

        return <span className={className} {...iconProps} />;
    }
}

export default Icon;
